import * as React from "react";
import { cn } from "@/lib/utils";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "flex min-h-[80px] w-full rounded border border-border bg-bg-input px-3 py-2 text-base text-text placeholder:text-text-3",
      "transition-colors duration-[120ms] ease-lz",
      "focus:border-accent focus:outline-none focus:ring-2 focus:ring-accent/35",
      "disabled:opacity-50",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";
